// The one registry of field help: every label, legend and non-obvious column header in the app
// has a "?" that opens its entry here in a modal (ui/help.tsx). Split by area so screens own
// their own file; composed here. tests/unit/help.test.ts fails when a view names a topic that is
// missing, or renders a raw <label>/<legend> that bypasses <Field>/<Fieldset>.
import { ASSISTANT_TOPICS } from "./topics/assistant";
import { BILLING_TOPICS } from "./topics/billing";
import { COMMON_TOPICS } from "./topics/common";
import { CUSTOMERS_TOPICS } from "./topics/customers";
import { FINANCE_TOPICS } from "./topics/finance";
import { OPERATIONS_TOPICS } from "./topics/operations";
import { PROMPT_LOGS_TOPICS } from "./topics/prompt-logs";
import { QUOTAS_TOPICS } from "./topics/quotas";
import { SETTINGS_TOPICS } from "./topics/settings";
import { TERMS_TOPICS } from "./topics/terms";
import { USAGE_EXPLORER_TOPICS } from "./topics/usage-explorer";
import type { HelpTopic } from "./topic";

export type { HelpTopic } from "./topic";

export const TOPICS = {
  ...COMMON_TOPICS,
  ...CUSTOMERS_TOPICS,
  ...TERMS_TOPICS,
  ...BILLING_TOPICS,
  ...FINANCE_TOPICS,
  ...OPERATIONS_TOPICS,
  ...PROMPT_LOGS_TOPICS,
  ...QUOTAS_TOPICS,
  ...SETTINGS_TOPICS,
  ...USAGE_EXPLORER_TOPICS,
  ...ASSISTANT_TOPICS,
} satisfies Record<string, HelpTopic>;

export type HelpId = keyof typeof TOPICS;

export function helpTopic(id: string): HelpTopic | null {
  return (TOPICS as Record<string, HelpTopic>)[id] ?? null;
}

/** "What is Markup?" — the accessible name of a label's help button. */
export function helpButtonLabel(label: string): string {
  return `What is ${label.trim().replace(/[?:]$/, "")}?`;
}
